<template>
  <div class="container">
    <div class="recap-container">
      <div class="recap-container-start">
        <div class="circle">
          <img src="../../public/photo_moi_no_background.png" alt="Photo de profil"/>
        </div>
      </div>
      <hr>
      <div>
        Arthur KEUSCH<br>
        Master 2 IoT (Internet of Things)<br>
        Permis B<br>
      </div>
      <hr>
      <div>
        <span class="text-blue">Téléphone :</span> 07.87.60.02.13<br>
        <span class="text-blue">Adresse :</span> 16 Faubourg de Lyon, 90 000 Belfort<br>
        <span class="text-blue">E-mail personnel :</span> arthur-keusch@orange.fr<br>
        <span class="text-blue">E-mail universitaire :</span> arthur-keusch@edu.umlp.fr<br>
      </div>
      <hr>
      <div>
        <span class="text-blue">Langues :</span>
        <div class="recap-container-langue">
          <CircularChart :text="'Anglais B1'" :percentage="100/6*3" :size="125"/>
          <CircularChart :text="'Allemand A2'" :percentage="100/6*2" :size="125"/>
        </div>
      </div>
      <hr>
      <div>
        <span class="text-blue">Loisirs :</span><br>
        Passionné de pâtisseries et de desserts<br>
        Jeux vidéo / réalité augmentée<br>
        Cinéma (science-fiction et action)<br>
        Passionné d’ingénierie sonore et lumière en spectacle<br>
      </div>
    </div>
    <div class="info-container">
      <h1 style="margin-bottom: 0;" class="text-blue">Formations</h1>
      <div class="info-container-card">
        <TimelineChart v-if="!useTimelineColumn" :items="formations"/>
        <TimelineColumn v-else :items="formations"/>
      </div>
      <h1 style="margin-bottom: 0;" class="text-blue">Languages et Frameworks</h1>
      <div class="info-container-card charts-grid">
        <div class="chart-card">
          <h2 style="text-align: center; margin-bottom: 0;">Développement Web</h2>
          <RadarChart :data="skillsWeb" :size="350"/>
        </div>
        <div class="chart-card">
          <h2 style="text-align: center; margin-bottom: 0;">Développement Logiciel</h2>
          <RadarChart :data="skillsLogiciel" :size="300"/>
        </div>
        <div class="chart-card">
          <h2 style="text-align: center; margin-bottom: 0;">Bases de données</h2>
          <RadarChart :data="skillsBDD" :size="350"/>
        </div>
      </div>
      <h1 style="margin-bottom: 0;" class="text-blue">Expériences</h1>
      <div class="info-container-card">
        <TimelineChart v-if="!useTimelineColumn" :items="this.experiences"/>
        <TimelineColumn v-else :items="this.experiences"/>
      </div>
      <h1 style="margin-bottom: 0;" class="text-blue">Autres</h1>
      <div class="info-container-card">
        <TimelineColumn :items="this.autres"/>
      </div>
    </div>
  </div>
</template>

<script>
import CircularChart from "@/components/CircularChart.vue";
import TimelineChart from "@/components/TimelineChart.vue";
import TimelineColumn from "@/components/TimelineColumn.vue";
import RadarChart from "@/components/RadarChart.vue";

export default {
  components: {
    RadarChart,
    TimelineChart,
    TimelineColumn,
    CircularChart
  },

  data: () => ({
    formations: [
      {
        date: 'Septembre 2025 - Aujourd\'hui',
        title: 'UMLP (UFR STGI), Montbéliard',
        text: `
<li>
  <span style="color: #00f0ff;">M1 et M2 - Master IoT (Internet of Things) :</span> Formation internationale de la Graduate School EIPHI
  <ul>
    <li>Totalité du cursus en anglais</li>
    <li>IoT, Embedded Systems, Machine Learning, Advanced Networks, Smart Cities, Cybersecurity, Virtual Systems</li>
  </ul>
<li>`
      },
      {
        date: 'Septembre 2022 - Juin 2025',
        title: 'IUT Nord Franche-Comté, Belfort',
        text: `
<li>
  <span style="color: #00f0ff;">3<sup>ème</sup> année en BUT Informatique :</span> Apprentissage dans le cadre de projets universitaires :
  <ul>
    <li>Python (IA), Arduino, Kotlin (Android), Swift (iOS)</li>
  </ul>
<li>
  <span style="color: #00f0ff;">2<sup>ème</sup> année en BUT Informatique :</span> Apprentissage de nouveaux langages informatique et frameworks dans le cadre d'un projet universitaire et d'un stage :
  <ul>
    <li>NodeJS/VueJS, PostgreSQL, PHP/Symfony</li>
  </ul>
</li>
<li>
  <span style="color: #00f0ff;">1<sup>ère</sup> année en BUT Informatique :</span> Apprentissage de nouveaux langages informatique et frameworks dans le cadre de projets universitaires :
  <ul>
    <li>HTML, CSS, Python, Java, JavaScript, C, MySQL, Flask</li>
  </ul>
</li>`
      },
      {
        date: 'Septembre 2019 - Juin 2022',
        title: 'Lycée Les Haberges, Vesoul',
        text: `
<li>
  <span style="color: #00f0ff;">Terminale Générale :</span>
  <ul>
    <li>SES (Sciences Economiques et Sociales)</li>
    <li>HGGSP (Histoire, Géographie, Géopolitique et Sciences Politiques)</li>
    <li>Option Sport</li>
  </ul>
<li>
  <span style="color: #00f0ff;">Première Générale :</span>
  <ul>
    <li>SES (Sciences Economiques et Sociales)</li>
    <li>HGGSP (Histoire, Géographie, Géopolitique et Sciences Politiques)</li>
    <li>NSI (Numérique et Sciences Informatique)</li>
    <li>Option Sport</li>
  </ul>
</li>`
      },
      {
        date: 'Septembre 2015 - Juin 2019',
        title: 'Collège Gérôme, Vesoul',
        text: 'Obtention du DNB mention Très Bien.'
      }
    ],
    skillsWeb: [
      {titre: 'HTML/CSS', valeur: 70},
      {titre: 'JavaScript', valeur: 90},
      {titre: 'PHP/Symfony', valeur: 80},
      {titre: 'Flask', valeur: 70},
      {titre: 'NodeJS/VueJS', valeur: 80},
      {titre: 'Spring Boot', valeur: 40}
    ],
    skillsLogiciel: [
      {titre: 'Java', valeur: 80},
      {titre: 'Python', valeur: 70},
      {titre: 'C', valeur: 40},
      {titre: 'C++', valeur: 40},
      {titre: 'Docker', valeur: 70},
      {titre: 'Kotlin', valeur: 50}
    ],
    skillsBDD: [
      {titre: 'MySQL', valeur: 80},
      {titre: 'PostgreSQL', valeur: 75},
      {titre: 'SQLServer', valeur: 75},
      {titre: 'Cassandra', valeur: 50},
      {titre: 'MongoDB', valeur: 65}
    ],
    screenWidth: window.innerWidth,
    experiences: [
      {
        date: 'Septembre 2025 - Juin 2026',
        title: 'Projet universitaire',
        text: `
<ul>
  <li>Développement de RESC-AI, une solution d'intelligence artificielle embarquée sur Android et Wear OS, destinée à l'assistance des sapeurs-pompiers et à la détection de chutes.</li>
  <li>Conception d'une application Android en Kotlin (Jetpack Compose) permettant l'exécution locale de modèles de langage (LLM), sans connexion Internet.</li>
  <li>Intégration de plusieurs moteurs d'inférence (ONNX Runtime, LiteRT) et mise en place d'un système RAG pour enrichir les réponses des modèles à partir de documents.</li>
  <li>Développement d'un système de téléchargement et de gestion des modèles d'IA, avec des outils de configuration et d'évaluation des performances.</li>
  <li>Conception et entraînement d'un modèle de Machine Learning (XGBoost) pour la détection de chutes à partir des données des capteurs inertiels d'une montre connectée (Galaxy Watch 5).</li>
  <li>Optimisation et évaluation des modèles pour une exécution locale sur des appareils mobiles aux ressources limitées.</li>
</ul>`
      },
      {
        date: '13 janvier 2025 - 2 mai 2025 (16 semaines)',
        title: 'Expérience professionnelle informatique',
        text: `Stagiaire à STELLANTIS (Belchamp)
<ul>
    <li>Développement d'une application web de gestion de projet.</li>
</ul>`
      },
      {
        date: 'Septembre 2024 - Janvier 2025',
        title: 'Projet universitaire',
        text: `
<ul>
    <li>Conception d’une application multi-architectures pour prédire la conservation des pommes en fonction des conditions de stockage et des données collectées.</li>
    <li>Développement et intégration de deux IA sur mesure, exécutées via des scripts Python, pour estimer la durée de conservation et déterminer les conditions de stockage optimales.</li>
    <li>Mise en place d’un serveur TCP multi-threadé en Java pour la centralisation des données et d’un serveur d’analyse média pour le traitement des images.</li>
    <li>Création d’une API REST en Node.js pour l’accès à MongoDB et la communication avec les IA.</li>
    <li>Développement d’une application mobile en Kotlin pour la capture d’images et d’un site web en Vue.js pour la visualisation des données.</li>
    <li>Conteneurisation et automatisation des processus de déploiement avec Docker.</li>
</ul>`
      },
      {
        date: 'Septembre 2024 - Janvier 2025',
        title: 'Article académique',
        text: `
<ul>
    <li>Rédaction d’un article académique sur la détection des attaques réseau via le Machine Learning.</li>
    <li>Étude des techniques de détection des Zero Day Attacks sur le dataset <a href="https://www.unb.ca/cic/datasets/cic-unsw-nb15.html">CIC-UNSW-NB15</a>.</li>
    <li>Conception d’un pipeline de traitement des données (nettoyage, extraction de caractéristiques, PCA).</li>
    <li>Comparaison de modèles de classification (Random Forest, XGBoost...) avec optimisation des hyperparamètres.</li>
    <li>Application de méthodes d’ensemble (Voting, Bagging, Stacking) pour améliorer la précision.</li>
    <li>Analyse des performances à l’aide de matrices de confusion.</li>
</ul>`
      },
      {
        date: '22 avril 2024 - 21 juin 2024 (9 semaines)',
        title: 'Expérience professionnelle informatique',
        text: `Stagiaire à OnlineFormaPro
<ul>
    <li>Développement d'une application web intégrant l'IA (PHP, Symfony, JavaScript, API d'OpenAI)</li>
</ul>`
      },
      {
        date: 'Juillet 2022, 2023, 2024 et 2025',
        title: 'Expérience professionnelle',
        text: `Ouvrier polyvalent à Inoverde (Fenaco)
<ul>
    <li>Travail à la chaine</li>
    <li>Maintenance de machines industrielles (filtres, précalibreuse, frigo, ...)</li>
    <li>Vérification quotidienne des frigos (température, taux d’O2 et de CO2 selon leur statut), des alarmes, des compresseurs et des systèmes de sécurité dans l’usine.</li>
</ul>`
      },
      {
        date: '2010 - Aujourd\'hui',
        title: 'Aides et travaux divers',
        text: `
<ul>
    <li>Tonte régulière d'un verger de ±400 arbres, tonte de jardins de particuliers.</li>
    <li>Création (SketchUp 2017 et Cura) et réalisation d’objets avec mon imprimante 3D.</li>
    <li>Création de sites web (JavaScript, HTML, CSS, SQL, Flask).</li>
    <li>Montages vidéos (Filmora12, Pinnacle Studio 22).</li>
</ul>`
      },
      {
        date: '12 au 14 décembre 2018',
        title: 'Gendarmerie de Vesoul, Observation de métiers',
        text: 'Stage de découverte de 3ème.'
      },
      {
        date: '10 et 11 décembre 2018',
        title: 'Théâtre Edwige Feuillière, Son-lumière et sécurité',
        text: 'Stage de découverte de 3ème.'
      },
      {
        date: '2010 - Aujourd\'hui',
        title: 'Jumelage et voyage',
        text: `Participation aux activités du jumelage avec Dornstetten (Allemagne) :
<ul>
    <li>Vente de produits régionaux.</li>
    <li>Immersion seul au collège pendant une semaine.</li>
    <li>Echange scolaire à Gerlingen (Allemagne).</li>
</ul>
Road trip (août 2023) de plus de 4 000 km en voiture depuis la France jusqu'à l'Est de la Roumanie (Moldavie) en plusieurs étapes (Munich, Vienne, Budapest, ...)`
      }
    ],
    autres: [
      {
        date: '',
        title: 'Compétences',
        text: `
<ul>
    <li>Sérieux, rigoureux, apprécie l'humour, autonome, apprécie le contact avec les personnes.</li>
    <li>Anglais niveau B1</li>
    <li>Allemand niveau A2</li>
</ul>`
      },
      {
        date: '',
        title: 'Loisirs',
        text: `
<ul>
    <li>Informatique / Programmation</li>
    <li>Passionné d’ingénierie sonore et lumière en spectacle</li>
    <li>Jeux vidéo / réalité augmentée</li>
    <li>Cinéma (science-fiction et action)</li>
    <li>Passionné de pâtisserie et de desserts</li>
    <li>Pratique en club de VTT pendant 7 ans (2015 - 2022)</li>
    <li>Pratique du ski tous les hivers (depuis 2010)</li>
</ul>`
      },
      {
        date: '',
        title: 'Pâtisserie et desserts',
        text: `
<ul>
    <li>Participation au concours de recette de cuisine inter-département de l'IUT Nord Franche-Comté :</li>
    <ul>
        <li>Lauréat 2024 du département Informatique ainsi que du prix d'excellence.</li>
        <li>
            <a href="https://www.linkedin.com/posts/david-markezic_butmp-butinfo-butcs-activity-7274335181761613824-hwKs/?originalSubdomain=fr">
                Publication LinkedIn
            </a>
        </li>
        <li>
            <a href="https://www.iut-nfc.univ-fcomte.fr/vie-des-campus/les-recettes-du-concours/">
                Publication site de l'IUT
            </a>
        </li>
    </ul>
    <li>Réalisation d'un gâteau différent par semaine pendant un an et demi.</li>
</ul>`
      }
    ]
  }),

  mounted() {
    window.addEventListener("resize", this.handleResize);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    }
  },

  computed: {
    useTimelineColumn() {
      return this.screenWidth < 1200;
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  height: 90vh;
  gap: 1rem;
}

.recap-container {
  width: 25%;
  background-color: #323336;
  border-radius: 30px;
  padding: 1rem;
}

.recap-container-start {
  display: grid;
  justify-content: center;
  margin-bottom: 10px;
}

.recap-container-langue {
  display: flex;
  justify-content: space-evenly;
}

.info-container {
  width: 75%;
  overflow: auto;
}

.info-container-card {
  background-color: #323336;
  border-radius: 30px;
  padding: 1rem;
}

.circle {
  width: 150px;
  aspect-ratio: 1;
  background: #323336;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  transition: transform 0.3s ease, filter 0.3s ease;
  filter: drop-shadow(0 0 10px transparent);
}

.circle > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 40%;
  border-radius: 0;
  transform: scale(1.1);
}

hr {
  margin: 10px 0;
  border: 0;
  height: 2px;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(255, 255, 255, 0.75), rgba(0, 0, 0, 0));
}

.text-blue {
  color: #00f0ff;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  justify-items: center;
}

.chart-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (max-width: 1000px) {
  .container {
    flex-direction: column;
    height: auto;
  }

  .recap-container {
    width: calc(100vw - 4rem);
  }

  .info-container {
    width: calc(100vw - 2rem);
  }
}
</style>
